import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    template: ''
})
export class NotFoundComponent implements OnInit {
    constructor(private router: Router) { }

    ngOnInit() {
        this.router.navigate(['/user/login'], {
            queryParams: { reason: 'notfound', url: this.router.url },
            replaceUrl: true   // kaputte URL aus der History entfernen
        });
    }
}